import React from 'react';
import Select from 'react-select';

const customStyles = {
  control: (provided) => ({
    ...provided,
    borderRadius: '3px',
    border: '1px solid rgba(27,32,50,.1)',
    padding: '12px 16px',
  }),
  indicatorSeparator: () => ({}),
  placeholder: (provided) => ({ ...provided, color: '#8f93a2', fontSize: 14 }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#4CBAA6',
  }),
};

const Dropdown = ({ name, options, placeholder, ...props }) => {
  return (
    <Select
      name={name}
      styles={customStyles}
      placeholder={placeholder}
      options={options}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: '#1b20321a',
          primary25: '#e6e6e6',
        },
      })}
      {...props}
    />
  );
};

export default Dropdown;
